import apiClient from './api';
import { Complaint } from '../types/complaint'; // تأكد من وجود هذا النوع
import { ComplaintStatus } from '../types/enums'; // تأكد من وجود هذا النوع
import { PagedResult, TableParams } from '../hooks/useServerSideTable';

// نوع بيانات لتحديث شكوى (عادةً يتم تحديث الحالة فقط من قبل المشرف)
export interface UpdateComplaintData {
  status: ComplaintStatus;
}

/**
 * جلب قائمة الشكاوى مع دعم للترقيم والبحث والفرز
 */
export const getPagedComplaints = async (params: TableParams): Promise<PagedResult<Complaint>> => {
  const response = await apiClient.get<{ data: PagedResult<Complaint> }>('/complaints/paged', { params });
  return response.data.data;
};

/**
 * جلب شكوى بواسطة ID
 */
export const getComplaintById = async (id: number): Promise<Complaint> => {
  const response = await apiClient.get<{ data: Complaint }>(`/complaints/${id}`);
  return response.data.data;
};

/**
 * تحديث شكوى موجودة (تحديداً الحالة)
 */
export const updateComplaintStatus = async (id: number, status: ComplaintStatus): Promise<Complaint> => {
  const response = await apiClient.put<{ data: Complaint }>(`/complaints/${id}`, { status });
  return response.data.data;
};

/**
 * حذف شكوى بواسطة ID
 */
export const deleteComplaint = async (id: number): Promise<void> => {
  await apiClient.delete(`/complaints/${id}`);
};
